import "./NavBarStyles.css";

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes, FaWindows } from "react-icons/fa";
import TypeWriterEffect from "react-typewriter-effect";

const NavBar = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const [color, setColor] = useState(false);
  const changeColor = () => {
    if (window.scrollY >= 100) {
      setColor(true);
    } else {
      setColor(false);
    }
  };

  const [dpstate, dpSetState] = useState(false);
  const ShowDP = () => {
    dpSetState(true);
  };
  const hideDP = () => {
    dpSetState(false);
  };

  window.addEventListener("scroll", changeColor);

  return (
    <div className={color ? "header header-bg" : "header"}>
      <Link to={"/"}>
        <p className="dp-title">
          <TypeWriterEffect
            textStyle={{ textAlign: "center" }}
            startDelay={1000}
            cursorColor="#e85a4f"
            multiText={["Dhan"]}
            multiTextDelay={900000000}
            typeSpeed={50}
            multiTextLoop
          />
        </p>
      </Link>
      <ul className={click ? "nav-menu active" : "nav-menu"}>
        <li>
          <Link to="/" className="un">
            Home
          </Link>
        </li>
        <li>
          <Link to="/project" className="un">
            Projects
          </Link>
        </li>
        <li>
          <Link to="/about" className="un">
            About
          </Link>
        </li>
        <li>
          <Link to="/contact" className="un">
            Contact
          </Link>
        </li>
      </ul>
      <div className="hamburger" onClick={handleClick}>
        {click ? (
          <FaTimes size={20} style={{ color: "#E8EAF6" }} />
        ) : (
          <FaBars size={20} style={{ color: "#E8EAF6" }} />
        )}
      </div>
    </div>
  );
};

export default NavBar;
